<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Talent echelon building</div>
      <div class="contentTitle">人才梯队打造</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
        <div class="yjh_item_text text_right">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">人才梯队打造简介！</div>
          </div>
          <div class="text_content">
            云久鸿将根据您的企业特点和相关需求，为您提供精确化的人才梯队打造服务。在服务过程中，我们将以战略合作伙伴的身份与您的企业管理团队精诚协作，建立企业人才资源池和相应的人才考察、选拔、培养、使用机制，挖掘和培养企业的人才梯队，为实践企业的愿景和战略目标提供坚实的人才保障。
          </div>
          <div class="text_otal">
            优势：为企业储备人才，避免企业人才断层，同时提升企业形象。
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">人才梯队打造</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">人才梯队打造简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          云久鸿将根据您的企业特点和相关需求，为您提供精确化的人才梯队打造服务。在服务过程中，我们将以战略合作伙伴的身份与您的企业管理团队精诚协作，建立企业人才资源池和相应的人才考察、选拔、培养、使用机制，挖掘和培养企业的人才梯队，为实践企业的愿景和战略目标提供坚实的人才保障。
        </div>
        <div class="mobile_yjh_item_otal">
          优势：为企业储备人才，避免企业人才断层，同时提升企业形象。"省心"、"省力"、"省钱"。
        </div>

        <div class="mobile_yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
}
</script>

<style lang="less" scoped></style>
